<template>
<div>
  <div class="container">
    <p v-bind:style="[bannerPlaceHolderWithoutDCCWeb.styles]" class="dcc-message" 
      v-if="bannerPlaceHolderWithoutDCCWeb && Object.keys(bannerPlaceHolderWithoutDCCWeb).length">
      {{bannerPlaceHolderWithoutDCCWeb.text}}
    </p>
  </div>
  <div class="content cardWrap">
    <form @submit.prevent="onBtn">
     <div class="row">
       <label for="cardnumber">{{config.labels.cardNumber}}</label>
       <input type="phone"
         :placeholder="config.placeholders.cardNumber" maxlength="19"
         v-model="card.number" name="cardnumber" autocomplete="cc-number"
         @keydown="(e) => isNumber(e, 'cardNumber')"
         @input="cardNumberChange"
         @blur="cardValidator"
         @focus="updateError('cardNumber')"
         v-bind:class="{ error: error['cardNumber']['status'] || !this.isLuhnPassed }"
       />
     </div>
     <div class="row desktopCvv">
       <div class="col-md-3 col-3 part" style="padding-left: 0 !important;">
         <label for="cc-exp-month">{{config.labels.month}}</label>
         <input type="number" :placeholder="config.placeholders.month"
           :min="this.card.year === getCurrYear() ? getCurrMonth() : 1" max="12"
           v-model="card.month" name="cc-exp-month" class="makeTiny"
           autocomplete="cc-exp" @keydown="isNumber" @blur="trailingZero"
           />
       </div>
       <!-- <div class="part sepLine">
         <span></span>
       </div> -->
       <div class="col-md-3 col-3" style="padding: 0 !important;">
         <label for="cc-exp">{{config.labels.year}}</label>
         <input type="number" :placeholder="config.placeholders.year"
           :min="getCurrYear()" max="99" name="cc-exp" v-model="card.year"
           autocomplete="cc-exp" @keydown="isNumber" @blur="trailingZero"
         />
       </div>
       <div class="col-md-3 col-3 desktopCvv">
       </div>
       <div class="col-md-3 col-3 desktopCvv " style="padding: 0 !important;">
         <label for="cvc">{{ cvvAlias || 'CVV' }}</label>
         <input type="password" :placeholder="config.placeholders.cvv"
           name="cvc" v-model="card.cvv" :maxlength="this.bannerPlaceHolderCvvMaxLength" autocomplete="cc-cvc"
           @keydown="isNumber" @blur="CVVValidator" @focus="updateError('cvv')"
           v-bind:class="{ error: error['cvv']['status'] }"
         />
       </div>
     </div>

     <div class="row mobileCvv">
       <div class="part">
         <label for="cc-exp-month">{{config.labels.month}}</label>
         <input type="number" :placeholder="config.placeholders.month"
           :min="this.card.year === getCurrYear() ? getCurrMonth() : 1" max="12"
           v-model="card.month" name="cc-exp-month" class="makeTiny"
           autocomplete="cc-exp" @keydown="isNumber" @blur="trailingZero"
           />
       </div>
       <div class="sepLine">
         <span></span>
       </div>
       <div class="part">
         <label for="cc-exp">{{config.labels.year}}</label>
         <input type="number" :placeholder="config.placeholders.year"
           :min="getCurrYear()" max="99" name="cc-exp" v-model="card.year"
           autocomplete="cc-exp" @keydown="isNumber" @blur="trailingZero"
         />
       </div>
       <div class="sepLine">
         <span></span>
       </div>
       <div class="part">
         <label for="cvc">{{ cvvAlias || 'CVV' }}</label>
         <input type="password" :placeholder="config.placeholders.cvv"
           name="cvc" v-model="card.cvv" :maxlength="this.bannerPlaceHolderCvvMaxLength" autocomplete="cc-cvc"
           @keydown="isNumber" @blur="CVVValidator" @focus="updateError('cvv')"
           v-bind:class="{ error: error['cvv']['status'] }"
         />
       </div>
     </div>

     <div class="row">
       <label for="ccname">{{config.labels.cardHolder}}</label>
       <input type="text" :placeholder="config.placeholders.cardHolder"
         name="ccname" v-model="card.name" autocomplete="cc-name" @keydown="onlyLetters"
         v-bind:class="{ error: error['name']['status'] }" @blur="nameValidator" @focus="updateError('name')"
         />
       <img v-if="bankInfo" class="brandLogo" :src="bankInfo.logo" :alt="bankInfo.name"/>
       <img v-else class="brandLogo brandLogo2" :src="staticImg + 'credit-card.png'" alt="Credit Card"/>
     </div>
     <div class="row" style="padding-top:1em">
       <div>
      </div>
     </div>
     <!-- <div v-if="!isMySavedCards" class="row" style="padding-top:1em">
        <div>
          <input type="checkbox" class="form-control input-sm" style="height:1em;width: 1em;display: inline-block" :checked="saveCard" @click="toggleSavecard"/> 
          Save card for faster checkout<br>
        </div>
      </div> -->
      <div v-if="isMySavedCards" class="my-saved-cards-btns pt-3">
        <div class="row">
          <div class="col-6">
            <a :class="isMySavedCardsDisable ? 'disabled' : ''" @click="toggleSavedCardLayout" style="background: #fff;border-color: #ccc;" class="btn pointer btn-primary btn-lg btn-block fregular text-uppercase">Cancel</a>
          </div>
          <div class="col-6">
            <a :class="isMySavedCardsDisable ? 'disabled' : ''" @click="addSavedCardDetailsForMysavedCards" style="color: #fff;" class="btn btn-primary pointer btn-lg btn-block fregular text-uppercase">Save Card</a>
          </div>
        </div>
      </div>
   </form>
   <span class="error-message">{{ errorText }}</span>
  </div>
</div>
</template>


<script>
  var $ = require('jquery')
  window.jQuery = $

  import {BankInfo} from './PaymentConstants.js'
  import * as CardValidator from 'card-validator'
  import CardInfo from 'card-info'
  import {mapGetters} from 'vuex'
  import Vue from 'vue'

  const exceptionKeys = [32, 13, 8, 37, 38, 39, 40]
  const CONFIG = {
    labels: {
      cardNumber: 'Card number',
      month: 'Month',
      year: 'Year',
      cardHolder: 'Name on card'
    },
    placeholders: {
      cardNumber: 'xxxx xxxx xxxx xxxx',
      month: '00',
      year: '00',
      cardHolder: 'Your Name',
      cvv: 'xxx'
    },
    showBank: true,
    showPaymentSystem: true
  }

  export default {
    name: 'cardInput',
    props: ['saveCard', 'toggleSavecard', 'isMySavedCards'],
    created () {
      this.config = Object.assign({}, CONFIG)
    },
    data () {
      return {
        card: {
          name: '',
          year: '',
          month: '',
          cvv: '',
          number: '',
          codeLength: ''
        },
        numberLength: 16,
        cvvLength: 3,
        saveAddress: true,
        cvvAlias: '',
        bankInfo: null,
        valid: false,
        errorText: '',
        errorMessage: [],
        error: {
          cardNumber: {
            status: false,
            message: 'Invalid card number'
          },
          cvv: {
            status: false,
            message: 'Invalid CVV'
          },
          name: {
            status: false,
            message: 'Incorrect name'
          }
        },
        isMySavedCardsDisable: false,
        staticImg: process.env.STATIC_IMG_SERVER2,
        isLuhnPassed: true
      }
    },
    validators: {
    },
    methods: {
      updateError (field) {
        this.error[field].status = false
        this.errorText = Object.values(this.errorMessage)[Object.values(this.errorMessage).length - 1]
        delete this.errorMessage[field]
      },
      cardValidator () {
        let dirtyNumber = ('' + this.card.number).replace(/\s/g, '')
        let cardInfo = new CardInfo(dirtyNumber)
        this.cvvLength = this.bannerPlaceHolderCvvMaxLength ? this.bannerPlaceHolderCvvMaxLength : 3
        let niceNumber = cardInfo.numberNice
        this.numberLength = cardInfo.numberLengths
        let cartNumberError = !this.numberLength.includes(dirtyNumber.length)
        this.isLuhnPassed = this.isValidCardNumberByLuhn(dirtyNumber)
        if (cartNumberError) {
          niceNumber = niceNumber.slice(0, 19) + ' ' + niceNumber.slice(19)
        }
        this.error.cardNumber.status = cartNumberError
        this.errorMessage['cardNumber'] = cartNumberError || !this.isLuhnPassed ? this.error.cardNumber.message : ''
        this.card.number = niceNumber
      },
      isValidCardNumberByLuhn (cardNumber) {
        // Remove all non-digit characters
        this.isLuhnPassed = false
        const digits = cardNumber.replace(/\D/g, '')
        let sum = 0
        let shouldDouble = false
        // Process digits from right to left
        for (let i = digits.length - 1; i >= 0; i--) {
          let digit = parseInt(digits[i])
          if (shouldDouble) {
            digit *= 2
            if (digit > 9) digit -= 9
          }
          sum += digit
          shouldDouble = !shouldDouble
        }
        return sum % 10 === 0
      },
      nameValidator () {
        this.error.name.status = !this.card.name
        this.errorMessage['name'] = !this.card.name ? this.error.name.message : ''
      },
      CVVValidator (val) {
        this.error.cvv.status = this.card.cvv.toString().length > this.cvvLength
        this.errorMessage['cvv'] = this.card.cvv.toString().length > this.cvvLength ? this.error.cvv.message : ''
      },
      validateMonth () {
        let currYear = this.getCurrYear()
        let currMonth = this.getCurrMonth()
        if (this.card.year === currYear && parseInt(this.card.month) < currMonth) {
          this.card.month = currMonth < 10 ? '0' + currMonth : currMonth
        }
      },
      validateYear () {
        let currYear = this.getCurrYear()
        if (this.card.year.toString().length > 2) {
          this.card.year = this.card.year.toString().substring(0, 2)
        }
        if (parseInt(this.card.year) < currYear && this.card.year.length > 1) {
          this.card.year = currYear
        }
      },
      getCurrYear () {
        return parseInt(new Date().getFullYear().toString().substr(2))
      },
      getCurrMonth () {
        return new Date().getMonth() + 1
      },
      makeCard () {
        var obj = Object.assign({}, this.card)
        obj.number = obj.number.replace(/\s/g, '')
        let cardInfo = new CardInfo(obj.number)
        this.card.codeLength = cardInfo.codeLength ? cardInfo.codeLength : 3
        this.numberLength = cardInfo.numberLengths
        obj.valid = this.valid && this.isLuhnPassed && (this.numberLength.includes(obj.number.length))
        return obj
      },
      isNumber (evt, field) {
        if (field && field === 'cardNumber') this.isLuhnPassed = true
        evt = evt || window.event
        let charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105))) && exceptionKeys.indexOf(charCode) === -1) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      onlyLetters (evt) {
        evt = evt || window.event
        let charCode = (evt.which) ? evt.which : evt.keyCode
        // additional exceptions: ,-'.
        let exceptionKeysName = exceptionKeys.concat([188, 189, 222, 190])
        if (!(charCode >= 65 && charCode <= 120) && exceptionKeysName.indexOf(charCode) === -1) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      trailingZero (evt) {
        let val = evt.target ? evt.target.value : evt
        if (parseInt(val, 10) < 10 && val.toString().charAt('0') !== '0') {
          if (evt.target.name === 'cc-exp') {
            this.card.year = '0' + val
            this.validateYear()
          } else if (evt.target.name === 'cc-exp-month') {
            this.card.month = '0' + val
            this.validateMonth()
          }
        }
      },
      toggleSavedCardLayout () {
        this.$emit('toggleSavedCardLayout', 'reset')
        this.isMySavedCardsDisable = false
      },
      addSavedCardDetailsForMysavedCards () {
        this.isMySavedCardsDisable = true
        const card = this.makeCard()
        if (!card.valid) {
          Vue.toasted.show('Please check card details & try again', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 3000})
          this.isMySavedCardsDisable = false
        } else {
          this.$emit('addSavedCardDetails')
        }
      },
      cardNumberChange () {
        const cardNum = this.card && this.card.number && this.card.number.replace(/\s/g, '')
        if (cardNum && cardNum.length === 6) {
          this.$store.dispatch('CHECK_TOKENISE_SUPPORT', cardNum)
        }
      }
    },
    mounted: function () {
    },
    watch: {
      'card.number' () {
        let dirtyNumber = ('' + this.card.number).replace(/\s/g, '')
        this.bankInfo = BankInfo.get(dirtyNumber) // Gets the brand info for card number

        let niceNumber = new CardInfo(dirtyNumber).numberNice
        if (niceNumber.length > 19) {
          niceNumber = niceNumber.slice(0, 19) + ' ' + niceNumber.slice(19)
        }
        this.card.number = niceNumber
        this.$emit('bank-info', this.bankInfo)
      },
      'card.name' () {
        this.card.name = this.card.name.toUpperCase().replace(/[^A-Z\s'-,.]/g, '')
      },
      'card.month' (newVal) {
        // limit chars to 2
        if (this.card.month.toString().length > 2) {
          this.card.month = this.card.month.toString().substring(0, 2)
        }
        if (parseInt(this.card.month) > 12) {
          this.card.month = 12
        }
        if (newVal.length > 1) {
          this.validateMonth()
        }
      },
      'card.cvv' (val) {
        this.card.cvv = val.replace(/\D/g, '').substring(0, this.cvvLength)
      },
      'card.year' (newVal) {
        this.validateYear()
        this.validateMonth()
      },
      'card': {
        handler () {
          let validName = this.card.name
          let validNumber = ('' + this.card.number).replace(/\s|\d/, '')
          this.valid = (
            validNumber && CardValidator.expirationMonth(this.card.month).isValid && CardValidator.expirationYear(this.card.year, new Date().getFullYear().toString().substring(2)).isValid && CardValidator.cvv(this.card.cvv, this.card.codeLength).isValid && validName && true
          )
          this.makeCard()
        },
        deep: true
      }
    },
    computed: {
      ...mapGetters(['upis', 'bannerPlcaeHolderData']),
      bannerPlaceHolderWithoutDCCWeb: function () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'DCC_WEB'.toLowerCase())
          if (bannerObj && Object.keys(bannerObj).length) {
            let bannerPhObj = {}
            bannerPhObj.styles = {
              backgroundColor: bannerObj.banner_color,
              color: bannerObj.banner_text_color
            }
            bannerPhObj.text = bannerObj.tag_text
            bannerPhObj.status = bannerObj.status
            return bannerPhObj
          }
        }
      },
      bannerPlaceHolderCvvMaxLength () {
        if (this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length) {
          let bannerObj = this.bannerPlcaeHolderData.find(bannerData =>
            bannerData.placeholder_for.toLowerCase() === 'Payment Screen'.toLowerCase() &&
              bannerData.status === true &&
              bannerData.product_type.toLowerCase() === 'CVV_MAX_LENGTH'.toLowerCase())
          this.cvvLength = 3
          if (bannerObj && Object.keys(bannerObj).length) {
            this.cvvLength = bannerObj.tag_text
            return bannerObj.tag_text
          }
          console.log('maxlength', this.cvvLength)
          return this.cvvLength
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

  .card-logo {
    height: 4em;
  }
  a.disabled {
    pointer-events: none;
    cursor: default;
  }
  .cardWrap {
    width: 420px;
    position: relative;
    margin: 0 auto;
    padding: 15px 35px;
    background: #F9F9F9;
    border-radius: 10px;
    border: 1px solid #DBDBDB;
    text-align: left;
  }

  .error {
    border-color: #eb3e25 !important;
  }

  .cardWrap .info {
    overflow: hidden;
  }

  ::placeholder {
    color: #ccc;
    font-size: 14px;
  }

  .cardWrap .row {
    position: relative;
    height: 40px;
    margin: 9px 0;
  }

  .cardWrap form {
    margin: 5px 0;
  }

  .cardWrap label {
    position: absolute;
    color: #9B9B9B;
    font-size: 10px;
    top: 6px;
    left: 16px;
    z-index: 1;
  }

  .cardWrap input {
    padding: 14px 16px 0;
    height: 40px;
    border: 1px solid #DBDBDB;
    box-shadow: none;
    width: 100%;
  }

  .cardWrap .part {
    width: 80px;
    display: inline-block;
    position: relative;
  }

  input:not([type=radio]):not([type=checkbox]) {
    border-radius: 10px;
    font-size: 14px;
    outline: 0;
    box-sizing: border-box;
    -webkit-appearance: none;
  }

  .cardWrap .sepLine {
    width: 18px;
  }

  .cardWrap .right {
    margin-left: 6em;
  }

  .cardWrap .whatIsIt {
    background: #2679FF;
    border-radius: 100px;
    width: 23px;
    height: 23px;
    position: absolute;
    bottom: -4px;
    right: -7px;
    color: #fff;
    line-height: 25px;
    font-size: 14px;
  }

  .cardWrap .submit {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 64px;
    border-bottom-left-radius: 34px;
    border-bottom-right-radius: 34px;
    text-align: center;
    transition: .3s border linear, .3s background linear;
  }

  .cardWrap button {
    border: 1px solid #fff;
    background: #d6d2d2;
    box-shadow: none;
    margin: 15px;
    height: 32px;
    width: 160px;
    border-radius: 20px;
    color: #fff;
    outline: none;
    font-size: 14px;
    cursor: not-allowed;
    transition: .3s color linear, .3s background linear;
  }

  .cardWrap .info {
    overflow: hidden;
  }

  .cardWrap .text {
        color: #9B9B9B;
    margin: 12px 0 0;
    padding: 0 22px;
    line-height: 22px;
  }

  .cardWrap .sum {
    font-size: 32px;
    float: right;
    margin: -41px 0 0;
  }

  input::-webkit-inner-spin-button {
    display: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
      transition: background-color 5000s ease-in-out 0s;
      background-color: #fff;
  }

  .cardWrap.valid .submit {
    background: transparent;
    border-top: 1px solid #dbdbdb;
  }

  .cardWrap.valid button {
    color: #fff;
    background: #6cc067;
    font-weight: bold;
    cursor: pointer;
    color: #fff;
    background: #6cc067;
    font-weight: bold;
    box-shadow: 1px 1px 0px 1px #437d3f;
    border: 0;
  }

  .cardWrap.valid button:active {
    box-shadow: -1px -1px 0px 1px #437d3f;
    top: 1px;
    left: 1px;
  }

  .cardWrap input.invalid {
    border-color: #a500009c;
  }

  .bankLogo, .bankLogo img {
    height: 4em;
  }

  .brandLogo {
    height: 40px;
    margin: 12px 0 0 19em;
  }

  .mobileCvv {
      display: none;
  }

  .error-message {
    color: #eb3e25;
  }

  .dcc-message {
    padding: 5px 15px;
    white-space: normal;
  }
  .brandLogo2 {
    height: 50px;
  }
  @media screen and (max-width: 450px) {
    .cardWrap {
      width: 95%;
    }

    label {
      left: 20px !important;
    }

    .cardWrap input {
      padding-right: 0em;
      padding-left: 20px;
    }

    .desktopCvv {
      display: none !important;
    }

    .desktopCvv input {
      display: none !important;
    }

    .cardWrap .part {
      width: 30% !important;
      display: inline-block;
    }

    .mobileCvv {
      display: block !important;
    }

    .sepLine {
      width: 1% !important;
      display: inline-block;
    }

    .brandLogo {
      height: 40px;
      margin: 1.5em 0 0 73%;
    }
    .brandLogo2 {
      height: 50px;
      margin: 1.2em 0 0 76%;
    }
  }
</style>



// WEBPACK FOOTER //
// cardInput.vue?0c1798c9